import { Checkbox, Divider, Paper, Tooltip, Typography } from "@material-ui/core";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { unoTheme } from "../../../assets/styles/unoTheme";

//Tables
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyAlertBalance from "../../utils/MyAlertBalance";
import MyTable from '../../utils/MyTable';
import DescriptionIcon from '@material-ui/icons/Description';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';

import DeleteIcon from '@material-ui/icons/Delete';
import DoneAllIcon from '@material-ui/icons/DoneAll';

import UnoButton from "../../utils/UnoButton";

import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';

//Redux
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

import {
    applyMaskAccount,
    applyMaskAmount,
    applyMaskAmountFreeDecimals,
    checkAssetsAndSubAssetsSameBalances,
    formatAnbimaDateToPt,
    getFirstDateDayMonth,
    getFirstDayMonth,
    getFirstPtDayMonth,
    getLastDayMonth,
    getLastPtDayMonth,
    getMonthName,
    getOperationLabel,
    isDateAfterClosedMonth
} from "../../utils/utils";

import { ClientAPI } from "../../../API/client";
import { CONSOLIDATED_SELECT_VALUE, getRegimeOptions } from "../../utils/accountRegimes";

//MyInputs
import MySelect from '../../utils/MySelect';

import moment from 'moment';

import CircularProgress from '@material-ui/core/CircularProgress';

import EventIcon from '@material-ui/icons/Event';
import AddIcon from '@material-ui/icons/Add';

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import InfosFundModal from '../../modals/InfosFundModal';
import QuotizationAssetModal from '../../modals/QuotizationAssetModal';
import TransactionsHistoryModal from '../../modals/TransactionsHistoryModal';

import NewSpecialClientQuotaModal from "../../modals/NewSpecialClientQuotaModal";
import MyAlertEndFund from "../../utils/MyAlertEndFund";
import MyAlertSpecialClientQuota from "../../utils/MyAlertSpecialClientQuota";
import { checkUserIsRole, roles } from "../../utils/user";
import { TransactionAPI } from "../../../API/transaction";
import ConfirmActionModal from "../../modals/ConfirmActionModal";

import XLSX from 'xlsx';
import { s2ab, downloadBlob } from '../../../controllers/ExcelController';
import { FundLocalQuotasAPI } from "../../../API/fund_local_quotas";


const bottomHeight = 40;
//const headerHeight = 170;
const headerHeight = 196;
//const headerHeight = 187;

const LightTooltip = withStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #000000"
        },
        color: theme.palette.common.white
    },
    tooltip: {
        fontSize: '15px',
        backgroundColor: theme.palette.common.white,
        border: "1px solid #000000",
        color: "#000000"
    }
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
    },

    header: {
        display: 'flex',
        flexDirection: 'column',
        //height: headerHeight,        
        backgroundColor: unoTheme.hoverTable,
        paddingBottom: '2px',
    },

    topHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        // paddingTop: theme.spacing(2),
        paddingTop: '12px',
        // paddingBottom: theme.spacing(2),
        paddingBottom: '12px',

        '& .actionButtonsHeader': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }
    },

    bottomHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        paddingTop: '12px',
        paddingBottom: '12px',
        borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)'
    },

    main: {
        //paddingBottom: theme.spacing(2),
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        //paddingTop: theme.spacing(2),
        height: 'calc(100% - ' + (headerHeight) + 'px)',

        // '& .mainTable': {
        //     //height: 'calc(100% - ' + (headerHeight + bottomHeight) + 'px)',
        //     height: 'calc(100% - ' + (headerHeight) + 'px)',
        // },

        '& .alertMain': {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            textAlign: 'left',
        }
    },

    bottom: {
        height: bottomHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    table: {
        height: 'calc(100% - 1px)',
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: '#1C2228',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px',
            },
        },
    },

    clickableQuotaRow: {
        cursor: 'pointer',
    },

    // detailRow: {
    //     cursor: "pointer",
    //     '& > *': {
    //         borderBottom: 'unset',
    //         padding: '3px 16px 3px 16px !important',
    //         textTransform: 'uppercase',
    //         color: unoTheme.defaultTextColor,
    //         fontWeight: 400,
    //         fontSize: '12px',
    //     },
    //     '&:nth-of-type(odd)': {
    //         backgroundColor: unoTheme.secondaryTuplaTable,
    //     },

    // },

    flexCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        height: '100%',
        paddingLeft: '0px !important',

        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    statusOff: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusPendent: {
        color: unoTheme.warningColor,
        fill: unoTheme.warningColor,
    },
    marginLeft: {
        marginLeft: '5px',
    },
    leftHeader: {

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelYear: {
        fontSize: '36px',
        paddingRight: theme.spacing(2),
    },
    spacingLeft1: {
        marginLeft: theme.spacing(1)
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },

    disableMonth: {
        position: 'absolute',
        height: '100%',
        width: '100%',
    },
    green: {
        color: unoTheme.greenMoney + ' !important'
    },
    red: {
        color: unoTheme.errorColor + ' !important',
    },
    blue: {
        color: 'blue !important',
    },
    warning: {
        color: unoTheme.warningColor
    },
    labelTotal: {
        fontSize: '13px',
        color: unoTheme.thirdColor
    },
    resultAmount: {
        fontSize: '13px',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    headerTotal: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',

        '& .infosHeaderTotal': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',

            '& .numberQuotas': {
                cursor: 'pointer',
                padding: '0px',
                margin: '0px',
                fontSize: '12px',
                textAlign: 'left',
                transition: 'all .3s ease',

                '&:hover': {
                    color: '#aaaaaa',
                }
            }
        }

    },
    leftHeader: {
        display: 'flex',
        //alignItems: 'center',
        flexDirection: 'column',
    },
    headerDate: {
        display: 'flex',
        alignItems: 'center',
        color: unoTheme.secondaryColor,
        fontSize: '12px',
        '& svg': {
            marginRight: '5px',
        },
        '& > *': {
            fontSize: '14px',
        }
    },

    cnpjLabel: {
        cursor: 'pointer',
        fontSize: '14px',
        color: unoTheme.secondaryColor,

        transition: 'all .3s ease',

        '&:hover': {
            color: '#615b5b',
        }
    },

    fundLabel: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#1C2228'
    },

    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    validationMessage: {
        color: unoTheme.errorColor,
        fontSize: '14px',
        textAlign: 'right',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    alertBalance: {
        marginBottom: '5px',
        '& .MuiAlert-message': {
            fontSize: '12px',
            padding: '0px',
            '& span': {
                verticalAlign: 'middle',
            }
        },
        '& .MuiAlert-icon': {
            padding: '0px',
        }
    },

    tabsAsset: {
        background: '#F3F5F8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    selectableInfo: {

        transition: 'all .3s ease',

        '&:hover': {
            color: '#aaaaaa',
        }
    },

    clickableSpanCota: {
        transition: 'all .1s ease',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '0.8em',
        color: unoTheme.mainColor,

        '&:hover': {
            color: '#aaaaaa',
        }
    },

    clickableSpanPl: {
        transition: 'all .1s ease',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '0.8em',
        color: unoTheme.greenMoney,

        '&:hover': {
            color: '#aaaaaa',
        }
    },

    cnpjAndFilterRegime: {

        display: 'flex',
        alignItems: 'center',
        //justifyContent: 'center',
    },

    lastQuotasInfo: {
        display: 'flex',
        alignItems: 'center',
        '& span': {
            fontSize: '12px',
        }
    },

    bold: {
        fontWeight: 'bold',
        cursor: 'pointer',

        '&:hover': {
            opacity: 0.7,
        }
    },

    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '0px !important',
        }
    },



}));

export const ADD_SPECIAL_QUOTA_CLIENT = "ADD_SPECIAL_QUOTA_CLIENT"
export const UPDATE_SPECIAL_QUOTA_CLIENT = "UPDATE_SPECIAL_QUOTA_CLIENT"

export default function DetailBalanceCollection(props) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.currentUser)
    const clientOn = useSelector(state => state.clientOn)

    const { content } = props

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [openQuotizationAssetModal, setOpenQuotizationAssetModal] = useState(false);

    //Histórico de movimentações: modal de conferência antes de gerar a planilha
    const [openTransactionsHistoryModal, setOpenTransactionsHistoryModal] = useState(false);
    const [transactionsHistoryRows, setTransactionsHistoryRows] = useState([]);

    //Fund infos modal
    const [openInfosFundModal, setOpenInfosFundModal] = useState(false);

    const [finalMapQuotasAnbimaByPtDate, setFinalMapQuotasAnbimaByPtDate] = useState();

    //Copy to DAIR
    const textRef = useRef(null);
    //Filtro de regime: as options usam o id do regime como value, então um único estado basta
    const regimeOptions = useMemo(
        () => getRegimeOptions(clientOn, {
            includeConsolidated: true,
            consolidatedLabel: 'Consolidado',
        }),
        [clientOn]);
    const [selectedRegimeType, setSelectedRegimeType] = useState(CONSOLIDATED_SELECT_VALUE); //detail


    const [openModalNewSpecialQuotaClient, setOpenModalNewSpecialQuotaClient] = useState(false); //detail

    //Dia clicado na aba Cotas, para abrir o modal de cota especial já naquela data
    const [preSelectedQuotaDate, setPreSelectedQuotaDate] = useState(null); //detail

    const endDayMonthDetail = useMemo(() => {
        if (clientOn?.client?.selectedMonth && clientOn?.client?.selectedYear) {

            return getLastDayMonth(clientOn.client.selectedMonth, clientOn.client.selectedYear)
        }
        return null;
    }, [clientOn.client.selectedMonth, clientOn.client.selectedYear])

    const firstDayMonthDetail = useMemo(() => {
        if (clientOn?.client?.selectedMonth && clientOn?.client?.selectedYear) {

            return getFirstDayMonth(clientOn.client.selectedMonth, clientOn.client.selectedYear, true)
        }
        return null;
    }, [clientOn.client.selectedMonth, clientOn.client.selectedYear])


    //Exibir componente para adicionar quota de cliente específico
    //ableToAddNewSpecial evita deixar cadastrar cota para carteira já fechada
    function maybeAddSpecialClientQuota(asset, ableToAddNewSpecial) {

        if (ableToAddNewSpecial == true && asset.special == true
            && !checkAssetsAndSubAssetsSameBalances(asset)) {

            return true;
        }
        return null;
    }

    //Em fundo special a cota é digitada à mão, então dia replicado é dia sem cota na base para esse
    //cliente e pode ser preenchido aqui mesmo. Não se exige saldo divergente como em
    //maybeAddSpecialClientQuota: preencher dia faltante é válido mesmo com o saldo conciliado
    function ableToEditSpecialQuotaInDay(row) {

        return content.data.special == true
            && !content.data.is_poupanca
            && content.ableToAddSpecialQuota == true //mês não fechado
            && checkUserIsRole(currentUser, [roles.admin, roles.superadmin, roles.advisor])
            && row.replicated == true;
    }

    function handleRegimeType(value) {

        //O MySelect devolve string; '0' é truthy, daí o parse explícito
        const regimeId = parseInt(value) || CONSOLIDATED_SELECT_VALUE;

        setSelectedRegimeType(regimeId)

        loadTotalInfosObject(content.data.transactions, regimeId, numberAccountOptions[selectedNumberAccountOption]);
    }

    //Filtro de contas 
    const [numberAccountOptions, setNumberAccountsOptions] = useState([]);
    const [selectedNumberAccountOption, setSelectedNumberAccountOption] = useState(0); //detail

    function doSelectNumberAccount(value) {
        setSelectedNumberAccountOption(value);

        loadTotalInfosObject(content.data.transactions, parseInt(selectedRegimeType), numberAccountOptions[value]);

    }
    // function handleRegimeType(value) {
    //     setSelectedRegimeType(value)
    //     loadTotalInfosObject(content.data.transactions, value);
    // }

    const [totalInfosObject, setTotalInfosObject] = useState({
        totalApplications: 0,
        totalApplicationsQuotas: 0,
        totalRescues: 0,
        totalRescuesQuotas: 0,
    });

    function loadTotalInfosObject(transactions, regimeType, accountOption) {

        //Existe a possibilidade de não haver transações para o ativo selecionado

        if (transactions) {


            let totalApplications = 0;
            let totalApplicationsQuotas = 0;
            let totalRescues = 0;
            let totalRescuesQuotas = 0;

            //Caso o regimeType seja 0 deve-se tratar os totais a partir de todas as transações, informação consolidada
            const transactionsInTheRegime = regimeType == 0 ?
                transactions
                :
                transactions.filter(transaction => transaction.account_regime_id == regimeType);

            console.log("TRASANCTIONS TO TOTAL: ", transactionsInTheRegime);
            console.log("accountOption: ", accountOption);
            console.log("regimeType: ", regimeType);

            const transactionsRegimeAndAccount = accountOption == null || accountOption == 'Conta' ?
                transactionsInTheRegime
                :
                transactionsInTheRegime.filter(transaction => transaction.account == accountOption)

            if (transactionsRegimeAndAccount) {
                transactionsRegimeAndAccount.forEach(element => {

                    if (element.operation_id == 1) {

                        totalApplications += element.amount ? parseFloat(element.amount) : 0;
                        totalApplicationsQuotas += element.result_qtd_quotas ? element.result_qtd_quotas : 0;

                    } else if (element.operation_id == 2) {

                        totalRescues += element.amount ? parseFloat(element.amount) : 0;
                        totalRescuesQuotas += element.result_qtd_quotas ? element.result_qtd_quotas : 0;

                    }

                });

                setTotalInfosObject({
                    totalApplications: totalApplications,
                    totalApplicationsQuotas: totalApplicationsQuotas,
                    totalRescues: totalRescues,
                    totalRescuesQuotas: totalRescuesQuotas,
                });
            }

        }



    }

    //Tab de saldos do ano ou descrição do ativo
    const [tabValue, setTabValue] = useState(0); //detail
    function handleChangeTabValue(event, value) {
        setTabValue(value)
    }

    function copyToClipboard(e, text) {
        e.stopPropagation();
        navigator.clipboard.writeText(text);
        dispatch(allActions.mainAlertActions.setMainAlert({
            type: 'success',
            message: 'Informação copiada para área de transferência!',
            show: true,
        }));
    };

    function doEditTransaction(transaction, index) {

        //console.log("T: ", transaction)
        // setEditAmount(applyMaskAmount(transaction.amount))
        // setEditOperation(parseInt(transaction.operation_id) - 1)
        // setEditDate(moment.utc(transaction.transaction_date));
        // setEdittingIndex(index)

        dispatch(allActions.rightContentActions.setRightContent({
            path: 'newTransaction',
            update: true,
            transactionToUpdate: transaction,
            data: { //Utilizado para enviar no retorno da tela
                path: 'detailBalanceCollection',
                data: content.data,
                //Mantém as seleções ao voltar da edição
                checkedTransactions: checkedTransactions,
                selectedMonth: content.selectedMonth,
                selectedYear: content.selectedYear,
                accounts: content.accounts,
                assets: content.assets,
                operations: content.operations
            }
        }))
    }

    async function doConcilio(balanceId) {

        //open backdrop
        setOpenBackdrop(true);

        let response = await ClientAPI.setBalanceReconciliaded(balanceId,
            currentUser.user.id,
            true);

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: 'Conciliação realizada com sucesso!'
            }))
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Erro ao realizar conciliação!'
            }))
        }

        dispatch(allActions.rightContentActions.setAction({
            task: 'updateConcilio',
            data: {
                balanceId: balanceId,
            },
        }))
        setOpenBackdrop(false);
    }

    function getAccountsWithTransactions(transactions) {

        let accountsWithTransactions = ["Conta"];

        if (!transactions) {
            return accountsWithTransactions;
        }

        transactions.forEach(t => {

            if (!accountsWithTransactions.includes(t.account)) {
                accountsWithTransactions.push(t.account);
            }

        });

        return accountsWithTransactions;
    }

    function getDataMapByDateTransaction(dateTransaction, attr) {
        if (finalMapQuotasAnbimaByPtDate && dateTransaction) {
            if (finalMapQuotasAnbimaByPtDate[moment.utc(dateTransaction).format('DD/MM/YYYY')]) {
                return applyMaskAmountFreeDecimals(finalMapQuotasAnbimaByPtDate[moment.utc(dateTransaction).format('DD/MM/YYYY')][attr], null, 20);
            }
        }

        return '-';
    }

    function createMapQuotasAnbimaByPtDate(quotasAnbima) {

        const mapQuotasAnbimaByPtDate = {};
        quotasAnbima.forEach(element => {

            const ptDate = formatAnbimaDateToPt(element.data_referencia);
            mapQuotasAnbimaByPtDate[ptDate] = {
                cota: element.valor_cota,
                pl: element.patrimonio_liquido
            }

        });

        setFinalMapQuotasAnbimaByPtDate(mapQuotasAnbimaByPtDate);

    }

    const [openConfirmActionModal, setOpenConfirmActionModal] = useState(false);
    //Seleções vindas do retorno da tela de edição (doEditTransaction)
    const [checkedTransactions, setCheckedTransactions] = useState(content.checkedTransactions || {});
    const handleCheckTransation = (event, transactionId) => {
        setCheckedTransactions(prev => ({
            ...prev,
            [transactionId]: event.target.checked,
        }));
    }

    const cleanChecked = () => {
        setCheckedTransactions(prev => {
            const newCheckeds = { ...prev };
            Object.keys(newCheckeds).forEach(key => {
                newCheckeds[key] = false;
            });
            return newCheckeds;
        });
    }

    //Transações exibidas na tabela, respeitando os filtros de regime e conta
    const visibleTransactions = useMemo(() => {
        if (!content?.data?.transactions) return [];
        return content.data.transactions.filter(
            el =>
                (selectedRegimeType == 0 || el.account_regime_id == selectedRegimeType)
                &&
                (selectedNumberAccountOption == 0 || el.account == numberAccountOptions[selectedNumberAccountOption])
        );
    }, [content, selectedRegimeType, selectedNumberAccountOption, numberAccountOptions]);

    const hasCheckedTransactions = Object.values(checkedTransactions).some(e => e === true);

    const selectAllTransactions = () => {
        setCheckedTransactions(prev => {
            const newCheckeds = { ...prev };
            visibleTransactions.forEach(transaction => {
                newCheckeds[transaction.id] = true;
            });
            return newCheckeds;
        });
    }

    const getIdsTransactionsToDelete = (checkeds) => {
        return Object.entries(checkeds)
            .filter(([id, checked]) => checked)
            .map(([id]) => parseInt(id));
    }

    const unableToChange = useMemo(() => {

        if (!clientOn?.client) return true;
        return !isDateAfterClosedMonth(moment.utc(new Date(clientOn.client.selectedYear, parseInt(clientOn.client.selectedMonth) - 1, 1)).format("DD/MM/YYYY"),
            clientOn.client.portfolio_closed,
            false)
    }, [clientOn])

    const doDeleteTransactions = async (transactionsIds) => {

        setOpenBackdrop(true);
        console.log("doDeleteTransactions: ", transactionsIds);
        for (let index = 0; index < transactionsIds.length; index++) {

            const response = await TransactionAPI.deleteTransaction(transactionsIds[index]);

        }

        setOpenBackdrop(false);
        dispatch(allActions.mainAlertActions.setMainAlert({
            show: true,
            type: 'success',
            message: 'Movimentações excluídas com sucesso!'
        }))
        dispatch(allActions.rightContentActions.update());

    }

    //Monta as linhas do histórico de movimentações do fundo
    //As mesmas linhas alimentam a modal de conferência e a planilha
    async function loadTransactionsHistory() {

        //Um fundo pode estar agrupado em mais de um registro de asset (várias contas/regimes)
        //A conta (number_account/account_id) está vinculada ao asset, não à transação:
        //cada asset corresponde a uma conta, então as transações herdam a conta do asset consultado
        const assetRecords = content.data.subAssets && content.data.subAssets.length > 0
            ? content.data.subAssets
            : [content.data];

        const responses = await Promise.all(assetRecords.map(asset => TransactionAPI.getTransactionsByAsset(asset.id)));

        let allTransactions = [];
        responses.forEach((response, index) => {
            if (response.success && response.body && response.body.rows) {
                const asset = assetRecords[index];
                //Marca cada transação com a conta do asset de origem
                const taggedRows = response.body.rows.map(row => ({
                    ...row,
                    _number_account: asset.number_account,
                }));
                allTransactions = allTransactions.concat(taggedRows);
            }
        });

        //Respeita o filtro de conta selecionado na tela (selectedNumberAccountOption)
        //Índice 0 = "Conta" (todas as contas)
        if (selectedNumberAccountOption != 0) {
            const selectedAccountNumber = numberAccountOptions[selectedNumberAccountOption];
            allTransactions = allTransactions.filter(t => t._number_account == selectedAccountNumber);
        }

        if (allTransactions.length === 0) {
            return [];
        }

        //Ordena por data da operação (ascendente)
        allTransactions.sort((a, b) => moment.utc(a.transaction_date).diff(moment.utc(b.transaction_date)));

        //Busca todas as cotas locais do fundo (todos os meses) e monta um mapa por data (DD/MM/YYYY)
        //O valor da cota do dia não vem na consulta de transações, fica armazenado em fund_local_quotas
        const clientId = clientOn && clientOn.client ? clientOn.client.id : null;
        const quotaValueByPtDate = {};
        //Num fundo special o valor_cota é placeholder e a cota real fica em valor_cota_<clientId>:
        //guardar a presença da chave permite avisar quando a cota do cliente não foi cadastrada no dia
        const hasClientQuotaByPtDate = {};
        const responseQuotas = await FundLocalQuotasAPI.getAllLocalQuotasByFundId(content.data.fund_id);
        if (responseQuotas.success && Array.isArray(responseQuotas.body)) {
            responseQuotas.body.forEach(monthRow => {
                try {
                    const jsonQuotas = typeof monthRow.json_quotas === 'string'
                        ? JSON.parse(monthRow.json_quotas)
                        : monthRow.json_quotas;
                    if (Array.isArray(jsonQuotas)) {
                        jsonQuotas.forEach(q => {
                            if (q.data_referencia == null) {
                                return;
                            }
                            const ptDate = formatAnbimaDateToPt(q.data_referencia);
                            //Fundos especiais possuem cota específica por cliente (valor_cota_<clientId>)
                            const hasClientQuota = clientId != null && q['valor_cota_' + clientId] != null;
                            const valorCota = hasClientQuota
                                ? q['valor_cota_' + clientId]
                                : q.valor_cota;
                            if (valorCota != null) {
                                quotaValueByPtDate[ptDate] = Number(valorCota);
                            }
                            hasClientQuotaByPtDate[ptDate] = hasClientQuota;
                        });
                    }
                } catch (e) {
                    console.log("ERROR parsing json_quotas: ", e);
                }
            });
        }

        return allTransactions.map(t => {

            const ptDate = t.transaction_date ? moment.utc(t.transaction_date).format('DD/MM/YYYY') : null;
            const quotaValue = ptDate != null && quotaValueByPtDate[ptDate] != null ? quotaValueByPtDate[ptDate] : null;
            const amount = t.amount != null ? parseFloat(t.amount) : null;

            //Quantidade de cotas = valor financeiro / valor da cota no dia
            const qtdQuotas = amount != null && quotaValue != null && quotaValue > 0
                ? amount / quotaValue
                : null;

            return {
                fundName: content.data.fund_name || '',
                numberAccount: t._number_account,
                transactionDate: t.transaction_date ? new Date(t.transaction_date) : null,
                ptDate: ptDate,
                operationLabel: getOperationLabel(t),
                operationId: t.operation_id,
                qtdQuotas: qtdQuotas,
                quotaValue: quotaValue,
                amount: amount,
                //Data sem linha no json_quotas também conta como cota do cliente não cadastrada
                hasClientQuota: ptDate != null && hasClientQuotaByPtDate[ptDate] === true,
            };
        });

    }

    //Etapa intermediária: exibe o histórico na modal antes de permitir a geração da planilha
    async function openTransactionsHistory() {

        setOpenBackdrop(true);

        try {

            const rows = await loadTransactionsHistory();

            if (rows.length === 0) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: 'Nenhuma movimentação encontrada para esse fundo!'
                }));
                return;
            }

            setTransactionsHistoryRows(rows);
            setOpenTransactionsHistoryModal(true);

        } catch (error) {
            console.log("ERROR openTransactionsHistory: ", error);
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Erro ao carregar histórico de movimentações!'
            }));
        } finally {
            setOpenBackdrop(false);
        }

    }

    function doExcelTransactionsHistory(rows) {

        try {

            const columns = ['Fundo', 'Conta', 'Data da operação', 'Operação', 'Quantidade de cotas', 'Valor de cota no dia', 'Valor financeiro'];

            const ws_data = [];
            ws_data.push(columns);
            rows.forEach(row => {

                ws_data.push([
                    row.fundName,
                    row.numberAccount ? applyMaskAccount(row.numberAccount) : '-',
                    row.transactionDate,
                    row.operationLabel,
                    row.qtdQuotas,
                    row.quotaValue,
                    row.amount,
                ]);
            });

            const sheetName = 'Movimentações';
            const fileName = 'Histórico Movimentações - ' + (content.data.fund_name || '')
                + ' - ' + moment.utc(new Date()).format('DD/MM/YYYY');

            const wb = XLSX.utils.book_new();
            wb.Props = {
                Title: fileName,
                Author: 'UNO',
            };
            wb.SheetNames.push(sheetName);
            const ws = XLSX.utils.aoa_to_sheet(ws_data);
            wb.Sheets[sheetName] = ws;

            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
            downloadBlob(
                new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
                fileName + '.xlsx'
            );

        } catch (error) {
            console.log("ERROR doExcelTransactionsHistory: ", error);
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Erro ao gerar histórico de movimentações!'
            }));
        }

    }

    const goToCreateTransaction = () => {
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'newTransaction',
            data: {
                path: 'detailBalanceCollection',
                fund: content.data,
                selectedMonth: content.selectedMonth,
                selectedYear: content.selectedYear,
                accounts: content.accounts,
                assets: content.assets,
                operations: content.operations
            }
        }))
    }

    useEffect(() => {

        console.log("DATA DETAIL BALANCE COLLECTION: ", content.data)
        console.log("DATA DETAIL BALANCE COLLECTION ACCOUNTS: ", content.accounts)

        //Fazendo a última cota subir
        // if (content && content.data && content.data.quotas_anbima) {
        //     content.data.quotas_anbima.reverse();
        // }

        //init totalInfosObject
        if (content && content.data) {

            // let arrayNumberAccountsOptions = [];
            // content.accounts.forEach(account => {
            //     arrayNumberAccountsOptions.push(applyMaskAccount(account.number_account));
            // });
            // arrayNumberAccountsOptions.unshift("Contas");

            //setNumberAccountsOptions(arrayNumberAccountsOptions);
            if (content.data.quotas_anbima) {
                createMapQuotasAnbimaByPtDate(content.data.quotas_anbima);
            }
            setNumberAccountsOptions(getAccountsWithTransactions(content.data.transactions));
            loadTotalInfosObject(content.data.transactions, 0, null);
        }


    }, [])

    return (
        <div className={classes.root}>


            <div className={classes.header}>

                <div className={classes.topHeader}>

                    <div className={classes.leftHeader}>
                        <div className={classes.headerDate}>
                            <EventIcon />
                            <Typography
                                align={'left'}

                                className={classes.labelMonth}>
                                {content && content.selectedMonth && content.selectedYear ?
                                    getMonthName(content.selectedMonth).toString().toUpperCase() + " " + content.selectedYear
                                    : ""}
                            </Typography>
                        </div>
                        <Typography
                            align={'left'}
                            className={classes.fundLabel}>
                            {content && content.data ? content.data.fund_name : ""}

                        </Typography>
                        <div className={classes.cnpjAndFilterRegime}>
                            <Typography
                                onClick={(e) => copyToClipboard(e, content && content.data ? content.data.cnpj : "")}
                                ref={textRef}
                                align={'left'}
                                className={classes.cnpjLabel}>
                                {content && content.data ? content.data.cnpj : ""}
                            </Typography>
                            <MySelect
                                style={{ marginLeft: '16px' }}
                                value={selectedRegimeType}
                                verysmall
                                onChange={(e) => handleRegimeType(e.target.value)}
                                options={regimeOptions.map((row) => (

                                    <option key={'regime-' + row.value} value={row.value}>{row.name}</option>

                                ))}
                            />

                        </div>

                    </div>

                    <div className={'actionButtonsHeader'}>

                        <IconButton onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>

                <Divider />

                <div className={classes.bottomHeader}>
                    <div className={classes.headerTotal}>
                        <Typography
                            className={classes.labelTotal}>
                            {'APLICAÇÔES: '}
                        </Typography>
                        <div class="infosHeaderTotal">
                            <Typography
                                className={[classes.resultAmount, classes.green].join(' ')}>
                                {applyMaskAmount(totalInfosObject.totalApplications, true)}
                            </Typography>
                            <Typography class="numberQuotas" onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(totalInfosObject.totalApplicationsQuotas, false))}>
                                {"(" + applyMaskAmountFreeDecimals(totalInfosObject.totalApplicationsQuotas, false) + ")"}
                            </Typography>
                        </div>

                    </div>
                    <div className={classes.headerTotal}>
                        <Typography
                            className={classes.labelTotal}>
                            {'RESGATES: '}
                        </Typography>
                        <div class="infosHeaderTotal">
                            <Typography
                                className={[classes.resultAmount, classes.red].join(' ')}>
                                {applyMaskAmount(totalInfosObject.totalRescues, true)}
                            </Typography>
                            <Typography class="numberQuotas" onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(totalInfosObject.totalRescuesQuotas, false))}>
                                {"(" + applyMaskAmountFreeDecimals(totalInfosObject.totalRescuesQuotas, false) + ")"}
                            </Typography>
                        </div>
                    </div>
                    {/* <div className={classes.headerTotal}>
                        <Typography
                            className={classes.labelTotal}>
                            {'TOTAL: '}
                        </Typography>
                        <div>
                            <Typography
                                className={[classes.resultAmount, content.data.resultAmount > 0 ? classes.green : classes.red].join(' ')}>
                                {content.data && content.data.resultAmount ?
                                    applyMaskAmount(content.data.resultAmount, true) : "-"}
                            </Typography>
                            <Typography className={classes.numberQuotas}>
                                {content.data && content.data.sumQuotasApplication && content.data.sumQuotasRescues ?
                                    applyMaskAmountFreeDecimals(content.data.sumQuotasApplication - content.data.sumQuotasRescues, false) : "-"}
                            </Typography>
                        </div>

                    </div> */}



                </div>

                {content && content.data
                    && content.data.quotas_anbima && content.data.quotas_anbima.length > 0 ?

                    <Paper square className={classes.tabsAsset}>
                        <div className={[classes.tabs, classes.shortWidthTab].join(' ')}>
                            <Tabs
                                value={tabValue}
                                indicatorColor="primary"
                                textColor="primary"
                                onChange={handleChangeTabValue}>

                                <Tab label={'Movimentações'} />
                                <Tab label="Cotas" />

                            </Tabs>
                        </div>

                        {
                            content && content.data && content.data.quotas_anbima ?
                                <div className={[classes.lastQuotasInfo, classes.spacingRight2].join(' ')}>
                                    {
                                        tabValue == 0 && !unableToChange ?
                                            <UnoButton
                                                className={classes.spacingRight2}
                                                size="verySmall"
                                                onClick={() => goToCreateTransaction()}
                                                type='warning'>
                                                {"+ MOV."}
                                            </UnoButton> : null
                                    }
                                    <UnoButton
                                        size="verySmall"
                                        onClick={() => openTransactionsHistory()}
                                        type='warning'>
                                        {"Hist. Movimentações"}
                                    </UnoButton>
                                    <UnoButton
                                        className={classes.spacingLeft2}
                                        size="verySmall"
                                        onClick={() => setOpenInfosFundModal(true)}
                                        type='primary'>
                                        {"Infos"}
                                    </UnoButton>
                                    <UnoButton
                                        className={classes.spacingLeft2}
                                        size="verySmall"
                                        onClick={() => setOpenQuotizationAssetModal(true)}
                                        type='success'>
                                        {"Cotização"}
                                    </UnoButton>
                                    <span className={classes.spacingLeft2}>
                                        Últ. cota:
                                    </span>
                                    <span
                                        onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(content.data.quotas_anbima[content.data.quotas_anbima.length - 1].valor_cota, false, 10))}
                                        className={[classes.bold, classes.spacingLeft1].join(' ')}>{applyMaskAmountFreeDecimals(content.data.quotas_anbima[content.data.quotas_anbima.length - 1].valor_cota, true, 10)}</span>
                                    <span className={classes.spacingLeft2}>
                                        Últ. PL:
                                    </span>
                                    <span
                                        onClick={(e) => content.data.quotas_anbima[content.data.quotas_anbima.length - 1].patrimonio_liquido != null ? copyToClipboard(e, applyMaskAmount(content.data.quotas_anbima[content.data.quotas_anbima.length - 1].patrimonio_liquido)) : null}
                                        className={[classes.bold, classes.spacingLeft1].join(' ')}>{content.data.quotas_anbima[content.data.quotas_anbima.length - 1].patrimonio_liquido != null ? applyMaskAmount(content.data.quotas_anbima[content.data.quotas_anbima.length - 1].patrimonio_liquido, true) : '-'}</span>
                                </div> : null
                        }

                    </Paper>

                    : null
                }


            </div>

            {
                tabValue == 0 ?


                    <div className={classes.main}>

                        {
                            //Verificar role
                            checkUserIsRole(currentUser,
                                [roles.admin,
                                roles.superadmin,
                                roles.advisor]) ?
                                <>
                                    {
                                        !content.data.is_poupanca && maybeAddSpecialClientQuota(content.data, content.ableToAddSpecialQuota) ?
                                            <MyAlertSpecialClientQuota
                                                role={currentUser.user ? currentUser.user.role : null}
                                                row={content.data}
                                                action={() => setOpenModalNewSpecialQuotaClient(true)} />
                                            : null
                                    }

                                    {!content.data.is_poupanca ?

                                        <>
                                            {
                                                content.data.subAssets ?

                                                    // exibir lista de alertas
                                                    content.data.subAssets.map((row, index) => (
                                                        <MyAlertBalance
                                                            key={'my-alert-balance-' + index}
                                                            role={currentUser.user ? currentUser.user.role : null}
                                                            row={row}
                                                            action={(param) => doConcilio(param)} />
                                                    ))

                                                    :

                                                    <MyAlertBalance
                                                        role={currentUser.user ? currentUser.user.role : null}
                                                        row={content.data}
                                                        action={(param) => doConcilio(param)} />
                                            }
                                        </> : null}
                                </> : null

                        }

                        <>
                            {
                                content.data.subAssets ?

                                    // exibir lista de alertas
                                    content.data.subAssets.map((row, index) => (
                                        <MyAlertEndFund
                                            key={'my-alert-end-fund-' + index}
                                            row={row}
                                            endDayMonthDetail={endDayMonthDetail}
                                            firstDayMonthDetail={firstDayMonthDetail} />
                                    ))

                                    :

                                    <MyAlertEndFund
                                        row={content.data}
                                        endDayMonthDetail={endDayMonthDetail}
                                        firstDayMonthDetail={firstDayMonthDetail} />
                            }
                        </>


                        {/* <TableContainer className={'mainTable'} component={Paper} elevation={0}>
                    <Table className={classes.table} size="small" aria-label="simple table"> */}

                        <MyTable
                            style={{ marginTop: '8px' }}
                            stickyHeader
                            infosBlack
                            sizeheaders="verySmall"
                            selectable={'true'}
                            size="small">
                            <colgroup>
                                <col width="5%" />
                                <col width="15%" />
                                <col width="17%" />
                                <col width="18%" />
                                <col width="20%" />
                                <col width="13%" />
                                <col width="22%" />
                                <col width="10%" />
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableTh} align="center">
                                        {
                                            !unableToChange && (
                                                hasCheckedTransactions ?
                                                    <IconButton style={{ color: unoTheme.redMoney }}
                                                        onClick={() => setOpenConfirmActionModal(true)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                    :
                                                    visibleTransactions.length > 0 &&
                                                    <Tooltip title="Selecionar todas" placement="top" arrow>
                                                        <IconButton onClick={() => selectAllTransactions()}>
                                                            <DoneAllIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                            )
                                        }
                                    </TableCell>
                                    <TableCell className={classes.tableTh} align="center">Data</TableCell>
                                    <TableCell className={classes.tableTh} align="center">Operação</TableCell>
                                    <TableCell className={classes.tableTh} align="center">
                                        <MySelect
                                            rawSelect
                                            value={selectedNumberAccountOption}
                                            verysmall
                                            onChange={(e) => doSelectNumberAccount(e.target.value)}
                                            options={numberAccountOptions.map((row, index) => (

                                                <option key={'account-number-option-' + index} value={index}>{row !== "Conta" ? applyMaskAccount(row) : row}</option>

                                            ))}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.tableTh} align="right">Cotas</TableCell>
                                    <TableCell className={classes.tableTh} align="center">DADOS DIA</TableCell>
                                    <TableCell className={classes.tableTh} align="right">Valor</TableCell>
                                    <TableCell className={classes.tableTh} align="center">APR</TableCell>
                                </TableRow>
                            </TableHead>

                            {
                                content && content.data && content.data.transactions ?

                                    <TableBody>
                                        {visibleTransactions.map((row, index) => (
                                            <TableRow className={classes.detailRow}
                                                key={'detail-transaction-' + index}
                                                onClick={() =>
                                                    checkUserIsRole(currentUser,
                                                        [roles.admin,
                                                        roles.superadmin,
                                                        roles.advisor]) ?
                                                        doEditTransaction(row, index) : null
                                                }>

                                                <TableCell align="center">
                                                    <Checkbox
                                                        checked={checkedTransactions[row.id] === true}
                                                        onClick={(e) => {
                                                            row.checkedDAIR = true;
                                                            e.stopPropagation()
                                                        }}
                                                        onChange={(e) => handleCheckTransation(e, row.id)} />
                                                </TableCell>

                                                <TableCell align="center" className={classes.selectableInfo}
                                                    onClick={(e) => copyToClipboard(e, moment.utc(row.transaction_date).format('DD/MM/YYYY'))}>
                                                    {moment.utc(row.transaction_date).format('DD/MM/YYYY')}
                                                </TableCell>

                                                <TableCell align="center" style={{ fontSize: '10px' }} className={classes.selectableInfo}
                                                    onClick={(e) => copyToClipboard(e, getOperationLabel(row))}>
                                                    {getOperationLabel(row)}
                                                </TableCell>

                                                <TableCell align="center" className={classes.selectableInfo}
                                                    onClick={(e) => copyToClipboard(e, applyMaskAccount(row.account))}>
                                                    {applyMaskAccount(row.account)}
                                                </TableCell>

                                                <TableCell align="right" className={classes.selectableInfo} onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(row.result_qtd_quotas))}>
                                                    {row && row.result_qtd_quotas ?
                                                        applyMaskAmountFreeDecimals(row.result_qtd_quotas) : '-'}
                                                </TableCell>

                                                <TableCell align="center" className={classes.selectableInfo}>
                                                    <div>
                                                        <LightTooltip
                                                            title={getDataMapByDateTransaction(row.transaction_date, 'cota')}
                                                            placement="top" arrow>
                                                            <span className={[classes.clickableSpanCota].join(' ')}
                                                                onClick={(e) => copyToClipboard(e,
                                                                    getDataMapByDateTransaction(row.transaction_date, 'cota')
                                                                )}>COTA</span>
                                                        </LightTooltip>
                                                        <span style={{ margin: '0px 4px' }}>|</span>
                                                        <LightTooltip
                                                            title={getDataMapByDateTransaction(row.transaction_date, 'pl')}
                                                            placement="top" arrow>
                                                            <span className={[classes.clickableSpanPl].join(' ')}
                                                                onClick={(e) => copyToClipboard(e,
                                                                    getDataMapByDateTransaction(row.transaction_date, 'pl')
                                                                )}>PL</span>
                                                        </LightTooltip>
                                                    </div>
                                                </TableCell>

                                                <TableCell align="right" className={
                                                    row.operation == 'Aplicação' ? classes.green : (
                                                        row.operation == 'Resgate' ? classes.red : classes.blue
                                                    )
                                                }>
                                                    {row && row.amount ? applyMaskAmount(row.amount, true) : null}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {row.apr_description_id || (row.apr_description && row.apr_description !== "") ? (
                                                        <IconButton
                                                            size="small"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                // Copia a descrição da APR para a área de transferência
                                                                const aprDescription = row.apr_description || "APR preenchida sem descrição";
                                                                navigator.clipboard.writeText(aprDescription);
                                                                dispatch(allActions.mainAlertActions.setMainAlert({
                                                                    type: 'success',
                                                                    message: 'Descrição da APR copiada para área de transferência!',
                                                                    show: true,
                                                                }));
                                                            }}
                                                        >
                                                            <CheckCircleIcon className={classes.statusOk} />
                                                        </IconButton>
                                                    ) : (
                                                        <ReportProblemIcon className={classes.statusPendent} />
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                    : null
                            }

                        </MyTable>

                    </div>

                    :

                    <div className={classes.main}>


                        <MyTable
                            style={{ marginTop: '8px' }}
                            stickyHeader
                            sizeheaders="verySmall"
                            size="small">
                            <colgroup>
                                <col width="30%" />
                                <col width="30%" />
                                <col width="40%" />
                            </colgroup>

                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Data</TableCell>
                                    <TableCell align="right">Valor cota</TableCell>
                                    <TableCell align="right">PL do dia</TableCell>
                                </TableRow>
                            </TableHead>

                            {
                                content && content.data && content.data.quotas_anbima ?

                                    <TableBody>
                                        {
                                            content.data.quotas_anbima.map((row, index) => (


                                                <TableRow className={[classes.detailRow, ableToEditSpecialQuotaInDay(row) ? classes.clickableQuotaRow : ''].join(' ')}
                                                    onClick={() => {
                                                        if (ableToEditSpecialQuotaInDay(row)) {
                                                            setPreSelectedQuotaDate(row.data_referencia);
                                                            setOpenModalNewSpecialQuotaClient(true);
                                                        }
                                                    }}
                                                    key={'detail-quota-' + index}>

                                                    <TableCell align="center">
                                                        {formatAnbimaDateToPt(row.data_referencia)}
                                                    </TableCell>

                                                    <LightTooltip
                                                        disableFocusListener={!row.valor_cota_default && !ableToEditSpecialQuotaInDay(row)}
                                                        disableTouchListener={!row.valor_cota_default && !ableToEditSpecialQuotaInDay(row)}
                                                        disableHoverListener={!row.valor_cota_default && !ableToEditSpecialQuotaInDay(row)}
                                                        title={ableToEditSpecialQuotaInDay(row) ?
                                                            'Cadastrar cota do cliente nesse dia'
                                                            : 'Cota específica para esse cliente, o valor padrão da cota é: ' + (row.valor_cota_default ? applyMaskAmountFreeDecimals(row.valor_cota_default, true) : '-')} placement="right" arrow>
                                                        <TableCell align="right" className={[!row.replicated ? classes.blue : classes.warning, row.valor_cota_default ? classes.bold : ''].join(' ')}>

                                                            <>{row.valor_cota != null ? applyMaskAmountFreeDecimals(row.valor_cota, true, 10) : '-'}</>

                                                        </TableCell>
                                                    </LightTooltip>

                                                    <TableCell align="right" className={classes.green}>
                                                        {row.patrimonio_liquido != null ? applyMaskAmount(row.patrimonio_liquido, true) : '-'}
                                                    </TableCell>


                                                </TableRow>



                                            ))

                                        }
                                    </TableBody>
                                    : null
                            }

                        </MyTable>


                    </div>

            }


            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }

            <NewSpecialClientQuotaModal
                open={openModalNewSpecialQuotaClient}
                asset={content.data}
                lastDayQuotaInMonth={content ? content.lastDayQuotaInMonth : null}
                preSelectedQuotaDate={preSelectedQuotaDate}
                month={clientOn.client.selectedMonth}
                year={clientOn.client.selectedYear}
                handleAction={() => {
                    setOpenModalNewSpecialQuotaClient(false);
                    setPreSelectedQuotaDate(null);
                }}>

            </NewSpecialClientQuotaModal>

            <QuotizationAssetModal
                open={openQuotizationAssetModal}
                asset={content
                    && content.data}
                handleCloseQuotizationModal={() => setOpenQuotizationAssetModal(false)}>

            </QuotizationAssetModal>

            <InfosFundModal
                open={openInfosFundModal}
                fund={content && content.data}
                handleCloseInfosFundModal={() => setOpenInfosFundModal(false)}>

            </InfosFundModal>

            <TransactionsHistoryModal
                open={openTransactionsHistoryModal}
                fundName={content && content.data ? content.data.fund_name : ''}
                special={content && content.data ? content.data.special : false}
                rows={transactionsHistoryRows}
                handleExcel={() => doExcelTransactionsHistory(transactionsHistoryRows)}
                handleClose={() => setOpenTransactionsHistoryModal(false)}>

            </TransactionsHistoryModal>

            <ConfirmActionModal
                open={openConfirmActionModal}
                title={'Excluir movimentações'}
                message={`Tem certeza de que deseja excluir ${Object.values(checkedTransactions).filter(e => e === true).length} movimentações selecionadas?`}
                handleAction={(action) => {
                    if (action) {
                        doDeleteTransactions(getIdsTransactionsToDelete(checkedTransactions))
                    }
                    cleanChecked();
                    setOpenConfirmActionModal(false)
                }}>
            </ConfirmActionModal>

        </div>
    );
}



